module.exports = __webpack_public_path__ + "img/logo.dc876399.png";